import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';



import BaseMultipleSelectorV2 from 'components/base/BaseMultipleSelectorV2';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import ReactHookFormSwitch from 'components/reactHookFormComponents/ReactHookFormSwitch';

import { CampaignType } from '../../../config/CustomEnums';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { GENERAL_TYPE } from '../../../models/CreateCampaignModel';
import {
  ReactHookFormErrorMessage,
  errorMessage,
  hasError,
} from '../../base/ErrorFieldMessage';

import { createAction } from 'utils';

import './PropertiesGeneralSection.scss';

const mapPropsToState = (state) => ({
  mallList: state.mall.pagedMallList,
});

function VisibleMallSection({ mallList }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { watch, setValue, control, formState } = useFormContext();
  const errors = formState.errors;

  const campaignType = watch('campaignType');
  const shouldFollowCouponsetMallFieldName = 'shouldFollowCouponsetMall';
  const watchShouldFollowCouponsetMall =
    watch(shouldFollowCouponsetMallFieldName) || false;
  const selectedVisibleMallsFieldName = 'malls';
  const watchSelectedVisibleMalls = watch(selectedVisibleMallsFieldName);

  const [refreshDate, setRefreshDate] = useState(new Date());

  useEffect(() => {
    dispatch(createAction('mall/getPagedMallList')({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, refreshDate]);
  console.log('@@45: ', errors);
  return (
    <>
      <label className="create-section-title">VISIBLE IN MALL</label>
      {/*
      {[CampaignType.couponsCampaign, CampaignType.ticketCampaign].indexOf(
        campaignType,
      ) ? (
        <ReactHookFormSwitch
          title={'Follow the related mall from the linked coupon set'}
          tips={
            'If ON, the campaign will be visible in the related mall from the linked coupon set or ticket. \n If OFF, manually which mall to show the campaign.'
          }
          valueFieldName={shouldFollowCouponsetMallFieldName}
        />
      ) : null} */}

      {watchShouldFollowCouponsetMall ? (
        <>
          <CustomTitleLabel title="Related mall from the linked coupon set" />
          <div>
            <label>mall name</label>
          </div>
        </>
      ) : (
        <Controller
          control={control}
          name={selectedVisibleMallsFieldName}
          render={({ field: value }) => {
            return (
              <>
                <BaseMultipleSelectorV2
                  title={`Select mall`}
                  size={['shorter']}
                  namespace={'mall'}
                  data={{
                    sourceData: mallList,
                    targetData: value.value || [],
                    targetChange: (value) => {
                      // setSelectedBrand(value);
                      setValue(selectedVisibleMallsFieldName, value, {
                        shouldDirty: true,
                      });
                    },
                  }}
                  loadMoreAction={() => {
                    dispatch(createAction('mall/getPagedMallList')({}));
                  }}
                  error={{
                    error: hasError(errors, 'malls'),
                  }}
                />
                <ReactHookFormErrorMessage errors={errors} id="malls" />
              </>
            );
          }}
        />
      )}
    </>
  );
}

export default connect(mapPropsToState)(VisibleMallSection);